<div class="wrapper">
	<ion-col>
		<span class="name">{{ customer?.isAnonymous ? ('menu_popover.guest' | translate) : customer?.name }}</span>
		<div class="separator"></div>
	</ion-col>

	@if (!customer) {
		<div>
			<ion-row class="ion-justify-content-center">
				<ion-spinner class="white" name="crescent"></ion-spinner>
			</ion-row>
		</div>
	}
	<ion-row (click)="privacy()">
		<ion-icon src="/assets/icon/privacy-icon.svg"></ion-icon>
		<ion-col>
			{{ 'menu_popover.privacy' | translate }}
		</ion-col>
	</ion-row>
	<ion-row (click)="tos()">
		<ion-icon src="/assets/icon/agbs.svg"></ion-icon>
		<ion-col>
			{{ 'menu_popover.terms' | translate }}
		</ion-col>
	</ion-row>
	<ion-row (click)="impressum()">
		<ion-icon src="/assets/icon/impressum-icon.svg"></ion-icon>
		<ion-col>
			{{ 'menu_popover.imprint' | translate }}
		</ion-col>
	</ion-row>
	@if (!customer?.isAnonymous) {
		<ion-row>
			<ion-button (click)="logout()" size="small">
				<ion-icon name="log-out-outline" slot="start"></ion-icon>
				{{ 'menu_popover.logout' | translate }}
			</ion-button>
		</ion-row>
	}
	<ion-row class="lang-row">
		<ion-col size="5">
			<span class="font-14 lang-title">{{ 'menu_popover.language' | translate }}:</span>
		</ion-col>

		<ion-col [class.selected]="languageEnum.German === translate.currentLang" class="icon-lang" size="3.5">
			<ion-icon (click)="changeLang(languageEnum.German)" src="../../assets/icon/germany.svg"></ion-icon>
			<span class="font-12">DE</span>
		</ion-col>
		<ion-col [class.selected]="languageEnum.GreatBritain === translate.currentLang" class="icon-lang" size="3.5">
			<ion-icon (click)="changeLang(languageEnum.GreatBritain)" src="../../assets/icon/united-kingdom.svg"></ion-icon>
			<span class="font-12">EN</span>
		</ion-col>
	</ion-row>
	<span class="version">{{ environment.version }}</span>
</div>
